import { DateTimeService } from "../../services/date-time-service"
import { useDateFormat } from "../../users/hooks/use-date-format"
import { useGetProjectDashboardQuery } from "../api"

export const useProjectDashboard = (projectId: string, queryOptions?: any) => {
  const { data: projectDashboard, ...requestStatus } = useGetProjectDashboardQuery(projectId, queryOptions)
  const { dateFormat } = useDateFormat()
  const dateTimeService = new DateTimeService({
    dateFormat,
    timeZone: projectDashboard?.timeZone,
    enableTimeComponent: projectDashboard?.enableTimeComponent,
  })

  const formattedPlannedStart = projectDashboard?.plannedStartDate
    ? dateTimeService.format(projectDashboard.plannedStartDate)
    : null
  const formattedPlannedEnd = projectDashboard?.plannedEndDate
    ? dateTimeService.format(projectDashboard.plannedEndDate)
    : null
  const formattedActualStart = projectDashboard?.actualStartDate
    ? dateTimeService.format(projectDashboard.actualStartDate)
    : null
  const formattedActualEnd = projectDashboard?.actualEndDate
    ? dateTimeService.format(projectDashboard.actualEndDate)
    : null

  return {
    ...requestStatus,
    projectDashboard,
    formattedPlannedStart,
    formattedPlannedEnd,
    formattedActualStart,
    formattedActualEnd,
  }
}
